import { parseApiError } from './apiError';
const base = () => `${process.env.REACT_APP_API_URL}api/verifications`;

const authHeaders = (token: string) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

export const getAllVerifications = async (token: string) => {
  const res = await fetch(base(), { headers: authHeaders(token) });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};

export const updateVerification = async (
  id: string,
  data: { status: 'approved' | 'rejected' | 'pending'; admin_notes?: string },
  token: string
) => {
  const res = await fetch(`${base()}/${id}`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify(data)
  });
  if (!res.ok) throw await parseApiError(res);
  return res.json();
};

/**
 * Récupère le recto ou le verso d'un document de vérification.
 *
 * Ces images ne sont pas servies en statique : elles ne sortent de l'API
 * qu'avec un jeton, ce qu'une balise <img src> ne sait pas envoyer. On les
 * télécharge donc en blob et on rend une URL locale, à révoquer quand le
 * composant se démonte.
 */
export const fetchVerificationDocument = async (
  id: string,
  side: 'front' | 'back',
  token: string
): Promise<string> => {
  const res = await fetch(`${base()}/${id}/document/${side}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) throw await parseApiError(res);
  return URL.createObjectURL(await res.blob());
};
